export default "__VITE_ASSET__azO32idB__"